import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AppSwitch } from "../../../../../../../shared/components/AppSwitch";
import { AppUnderlinedTitle } from "../../../../../../../shared/components/AppUnderlinedTitle";
import { NormalizedStorageObject } from "../../../../../../../services/api/instances/storageApi/types/object_types";
import { ChatbotValue } from "../../../../../../../services/api/instances/botApi/types";
import { TValueForService } from "../../../../../../../services/api/instances/storageApi/types/service_types";
import { getUpdatedChatbotValue } from "../../../../../helpers/getUpdatedChatbotValue";
import styles from "./styles.module.css";

interface Props {
  bot: NormalizedStorageObject<ChatbotValue>;
  saveChatbotValue: (
    value: TValueForService<"ai_agents_telegram_bots">,
  ) => void;
}

export const SecurityHeader = (props: Props) => {
  const { t } = useTranslation();

  const handleChangeSecurity = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!props.bot?.value) return;
      const updatedValue = getUpdatedChatbotValue(props.bot.value, {
        security_check: event.target.checked,
      });
      props.saveChatbotValue(updatedValue);
    },
    [props.bot?.id],
  );

  return (
    <AppUnderlinedTitle
      className={styles.title}
      leftContent={t("chatbot.security_title")}
    >
      <AppSwitch
        className={styles.switch}
        checked={props?.bot?.value?.tg_bot_object?.security_check ?? false}
        onChange={handleChangeSecurity}
      />
    </AppUnderlinedTitle>
  );
};
